import React, { useState } from 'react';
import { Card, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import './ProjectCard.css';
import PopUpPage from '../../common/popUpPage/PopUpPage';

export default function ProjectCard({ title, description, detail }) {
    const [modalShow, setModalShow] = useState(false);

    return (
        <>
            <Card className="project-card border-0 bg-light mb-5 mx-5">
                <Card.Body className="d-flex flex-column justify-content-between p-4">
                    <Card.Title className="fs-1">
                        <div>{title}</div>
                        <div className="title-background" />
                    </Card.Title>

                    <Card.Text className="">{description}</Card.Text>
                    <Col md="12" className="text-start">
                        <Button
                            size="sm"
                            className="cta-btn ms-auto fs-4 px-4 py-2"
                            onClick={() => setModalShow(true)}
                        >
                            Learn More
                        </Button>
                    </Col>
                </Card.Body>
            </Card>

            {modalShow && (
                <PopUpPage
                    show={modalShow}
                    detail={detail}
                    onHide={() => setModalShow(false)}
                />
            )}
        </>
    );
}

// PropTypes definitions
ProjectCard.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    detail: PropTypes.shape({
        imgSrc: PropTypes.string,
        title: PropTypes.string.isRequired,
        body: PropTypes.arrayOf(
            PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.shape({
                    subHeading: PropTypes.string.isRequired,
                    content: PropTypes.arrayOf(PropTypes.string).isRequired,
                }),
            ])
        ).isRequired,
    }).isRequired,
};
